<div class="search-places">
  <div class="search-places__header">
    @if (navigation()?.length > 0) {
      <button
        (click)="navigateBack()"
        aria-label="Tillbaka"
        class="icon-button navigate_back"
        type="button"
      >
        <app-ui-icon color="var(--grey-5)" name="chevron_back" size="md"></app-ui-icon>
      </button>
    } @else {
      <div></div>
    }
    <div class="search-places__top-container">
      <div class="search-places__title">
        @switch (hierarchyLevel()) {
          @case (0) {
            <span>Välj län</span>
          }
          @case (1) {
            <span>Välj kommun/tätort</span>
          }
          @case (2) {
            <span>Välj stadsdel</span>
          }
        }
      </div>
    </div>
    @if (showCloseButton()) {
      <button
        (click)="onCloseClick()"
        aria-label="Stäng"
        class="icon-button close"
        type="button"
      >
        <app-ui-icon color="var(--grey-5)" name="close" size="md"></app-ui-icon>
      </button>
    } @else {
      <div></div>
    }
  </div>

  <div class="search-places__body">
    <div class="search-places__inner">
      <div class="search-places__filters">
        @for (listItem of currentItems(); let j = $index; track listItem.id) {
          <div class="search-places__body-dropdown-list-item">
            @if (!listItem.children || listItem.children.length == 0) {
              <div
                [ngClass]="newPlacesFieldValue() === listItem.name
                ? elementToggleEnum.ACTIVE
                : elementToggleEnum.NORMAL"
                class="search-places__body-list-item">
                <div class="search-places__body-category">
                  <div
                    (click)="onListItemClick(listItem.name)"
                    class="search-places__body-category__text"
                  >{{ listItem.name }}
                  </div
                  >
                </div>
                <div class="search-places__body-badge">
                  {{ listItem.caregiverUnitsCount | filterCount }}
                </div>
              </div>
            }

            @if (listItem.children && listItem.children.length > 0) {
              <div class="search-places__body-list-item">
                <div class="search-places__body-category">
                  <div
                    (click)="onListItemClick(listItem.name)"
                    class="search-places__body-category__text"
                  >{{ listItem.name }}
                  </div
                  >
                </div>
                <div
                  (click)="loadChildren(listItem)"
                  class="info with-children"
                  matTooltip="öppna underkategorier"
                  matTooltipClass="varden-tooltip"
                  matTooltipPosition="above"
                >
                  <div class="search-places__body-badge">
                    {{ listItem.caregiverUnitsCount | filterCount }}
                  </div>
                  <div class="search-places__body-chevron">
                    <app-ui-icon
                      class="chevron-right"
                      color="var(--green-1)"
                      name="chevron_right"
                      size="sm"
                    ></app-ui-icon>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>


